module.exports = __webpack_public_path__ + "img/tip_2.1a9b9e01.png";